<template>
  <section  class="section section_bg mobile_div first_page">

    <loading-block v-if="is_load==false" :loading="!is_load"/>




        <div class="container mobile_div total_page" v-if="is_load">

            <div class="row   block_row list-group-item service_card_mini mt-4 d-flex  justify-content-center" v-for="category in services" :key="category.last_id"
                v-if="services.length>0">
              <div class="row">
                <div class="col-md-4 col-12 service_image_block img_div">
                  <v-lazy-image :src="image_url+category.image" class=" img-thumbnail col-12" :alt="category.name"/>
                  <br>

                </div>
                <div class="col-md-8 col-12  mini_service_div">
                  <h2 class="text-center " ><router-link tag="a" class="link_service "
                      :to="{name: 'service_page', params: {service_id:category.alias  }}">{{ category.name}}</router-link></h2>

                  <editorjsrender v-if="category.content_json && category.content_json.blocks"  :blocks_json="category.content_json.blocks" :isshort="true"></editorjsrender>





                </div>
              </div>
              <div class="row">
                <div class="col-md-4 col-12">
                  <div class="d-flex justify-content-center">
                  <router-link class="btn mt-5" tag="a"
                      :to="{name: 'service_new_request',params:{id:category.last_id}}">Заказать</router-link>
                  </div>
                </div>
                <div class="col-md-8 col-12">
                  <div class="d-flex justify-content-center">
                  <router-link class="btn mt-5" tag="a"
                      :to="{name: 'service_page', params: {service_id:category.alias  }}">Подробнее</router-link>
                    </div>
                </div>
              </div>

            </div>
          <div class="row   block_row list-group-item service_card_mini mt-4 d-flex  justify-content-center" v-if="total>offset">
            <div class="row second_section d-flex justify-content-center">
              <button class="btn" @click="loadServices">Загрузить еще</button>

            </div>
          </div>







      </div>

  </section>



</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import {eventBus} from "../../main";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Editorjsrender from "@/models/Editorjsrender.vue";
import VLazyImage from "v-lazy-image/v2";



var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {VLazyImage,LoadingBlock,'editorjsrender': Editorjsrender,},
  data() {
    return {
      'limit':10,
      'offset':0,
      'total':0,
      "services":[],
      "works":[],
      "is_load":false,
      "image_url":null,
    }
  },
  mounted() {

    var app=this;
    app.loadServices();

  },
  methods: {
    loadServices(){
      var app=this;
      Api.loadServicesList(app.limit,app.offset,function (data) {

        app.image_url = Vue.config.IMAGE_URL;
        app.total=data.total;
        app.services =app.services.concat( data.services);
        app.offset=data.offset;
        app.is_load=true;



      })
    },
    callModalAddProject() {
      var app=this;
      eventBus.$emit("call_modal_add_project", {'current_form_category':app.service.last_id})
      {

      }
    },




  }
};
</script>
